"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.youtube = void 0;
var qs_1 = require("qs");
exports.youtube = function (axios) {
    return {
        getYoutubePlayLists: function (request) {
            var query = qs_1.stringify(request.params, { arrayFormat: 'comma' });
            return axios.get("/youtube/play-lists?" + query);
        }
    };
};
